import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  Block, Content, StyledImage, StyledLink,
} from './styles';

// * className {string} a className from CMS that controls styling
// * image {obj} the data for the image if displayed
// * imageAlignment {string} determines what side the image should be on
// * title {richText} data that makes up the title of the section
// * bodyText {richText} data that makes up the body of the section

function GraphicContentBlock({ sectionId, className, data }) {
  if (!data) return null;
  const {
    imageAlignment,
    image,
    imageSharp,
    titleHtml,
    bodyTextHtml,
    ctaLink,
    ctaText,
    ctaType,
    queryString,
    ariaLabel,
  } = data;

  /* Lifecycle function that injects prefinery popup when using the prefinery cta, on component mount for the first time */
  useEffect(() => {
    if (ctaType === 'prefinery' && !document.getElementById('prefinery_js')) {
      // script tag with code inside
      const prefineryScript = document.createElement('script');
      prefineryScript.text = `{prefinery=window.prefinery||function()
    {(window.prefinery.q = window.prefinery.q || []).push(arguments)};
      document.body.appendChild(prefineryScript)}`;

      // script tag with js to load from url
      const prefineryJs = document.createElement('script');
      prefineryJs.src = 'https://widget.prefinery.com/widget/v2/pp6us4ef.js';
      prefineryJs.id = 'prefinery_js';
      document.body.appendChild(prefineryJs);

      // script tag to close prefinery modal by clicking outside of it, provided by prefinery team and modified to work
      const prefineryClose = document.createElement('script');
      prefineryClose.text = `document.addEventListener("click", (evt) => {
                    const popupModal = document.getElementById("prefinery_popup");
                    const popupOverlay = document.getElementById("prefinery_overlay");
                    let targetElement = evt.target;
                
                    do {
                        if (targetElement == popupModal) {
                            return;
                        }
                        targetElement = targetElement.parentNode;
                    } while (targetElement);
                    if(popupOverlay){
                      popupOverlay.style.display = "none";
                    }
                });`;
      document.body.appendChild(prefineryClose);
    }
  }, []);

  return (
    <Block id={sectionId} className={[className, imageAlignment]}>
      <StyledImage src={imageSharp} alt={image.altTag} />
      <Content>
        {ReactHtmlParser(titleHtml)}
        {ReactHtmlParser(bodyTextHtml)}
        {ctaText && ctaLink && (
          <StyledLink
            to={`${ctaLink.url}/`}
            className={`${
              ctaType === 'prefinery'
                ? 'solid-on-dark-bg prefinery-form-cta'
                : ctaType
            }`}
            ariaLabel={ariaLabel}
            queryString={queryString}
          >
            {ctaText}
          </StyledLink>
        )}
      </Content>
    </Block>
  );
}

GraphicContentBlock.propTypes = {
  className: PropTypes.string,
  sectionId: PropTypes.string,
  data: PropTypes.shape().isRequired,
};

GraphicContentBlock.defaultProps = {
  className: null,
  sectionId: null,
};

export default GraphicContentBlock;
